import { forwardRef, type ReactNode } from "react";
import styles from "./section.module.css"; // or use Tailwind

export const Section = forwardRef<
  HTMLElement,
  {
    children: ReactNode;
    className?: string;
  }
>(({ children, className = "" }, ref) => {
  return (
    <section ref={ref} className={`${styles.section} ${className}`}>
      {children}
    </section>
  );
});
